import { XPath } from '../../controls/xpath';
import { AfterViewInit, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LoadingPanelService } from '../../shared/loading-panel/loading-panel.service';
import { ToastService, ToastType } from '../../shared/toast/toast.service';
import { XmlPropertyPromotionFilter, XmlPropertyPromotionFilterEntity } from '../models/xml-property-promotion-filter';
import { XmlPropertyPromotionFieldEntity } from '../models/xml-property-promotion-field';
import { DeveloperService } from '../services/developer.service';
import { CurrentUserService } from '../../user/services';
import { GridService } from '../../shared/grid/grid.service';
import { SvgIconComponent } from '../../shared/icons/svg-icon.component';
import { PermissionRequiredDirective } from '../../shared/authentication/permission-required.directive';
import { ChangeLogLinkComponent } from '../../shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from '../../shared/change-log/change-log-link-entity/change-log-link-entity.directive';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../../shared/grid/biz-grid.directive';
import { DxoEditingModule, DxoPopupModule, DxoFormModule, DxiItemModule, DxoColumnFixingModule, DxiColumnModule, DxiValidationRuleModule, DxiButtonModule, DxoLookupModule } from 'devextreme-angular/ui/nested';
import { BizUserColumnDirective } from '../../shared/grid/biz-grid-user.directive';
import { BizDateColumnDirective } from '../../shared/grid/biz-grid-date.directive';
import { DxTemplateModule } from 'devextreme-angular/core';
import { BizGridFiltervalues } from 'src/app/shared/grid/biz-grid-filtervalues';
import { ColumnEditCellTemplateData } from 'devextreme/ui/data_grid';

@Component({
    selector: 'app-developer-xml-property-promotions',
    templateUrl: './developer-xml-property-promotions.component.html',
    styleUrls: ['./developer-xml-property-promotions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, PermissionRequiredDirective, ChangeLogLinkComponent, ChangeLogLinkEntityDirective, DxDataGridModule, BizDataGridDirective, DxoEditingModule, DxoPopupModule, DxoFormModule, DxiItemModule, DxoColumnFixingModule, DxiColumnModule, DxiValidationRuleModule, BizUserColumnDirective, BizDateColumnDirective, DxiButtonModule, DxTemplateModule, DxoLookupModule, XPath]
})
export class DeveloperXmlPropertyPromotionsComponent implements OnInit, AfterViewInit {
    isSystemProperty = false;
    xmlPropertyPromotionFilters: XmlPropertyPromotionFilter[] = [];
    systemProperties: SystemProperty[] = [
        { Name: 'Custom', PropertyName: '', PropertyNamespace: '' },
        { Name: 'Message Number', PropertyName: 'MessageNumberIn', PropertyNamespace: 'http://link.bizbrains.com/properties/document' },

        { Name: 'Document Number', PropertyName: 'DocumentNumber', PropertyNamespace: 'http://link.bizbrains.com/properties/document' },
        { Name: 'Document Originating ID', PropertyName: 'OriginatingId', PropertyNamespace: 'http://link.bizbrains.com/properties/document' },
        { Name: 'Interchange Number', PropertyName: 'InterchangeNumber', PropertyNamespace: 'http://link.bizbrains.com/properties/interchange-in' },
        { Name: 'Interchange Originating ID', PropertyName: 'OriginatingId', PropertyNamespace: 'http://link.bizbrains.com/properties/interchange-in' },

        { Name: 'Receiver ID 1', PropertyName: 'IdentificationValue', PropertyNamespace: 'http://link.bizbrains.com/properties/partner-out' },
        { Name: 'Receiver ID 1 Qualifier', PropertyName: 'IdentificationQualifier', PropertyNamespace: 'http://link.bizbrains.com/properties/partner-out' },
        { Name: 'Receiver ID 2', PropertyName: 'IdentificationValue2', PropertyNamespace: 'http://link.bizbrains.com/properties/partner-out' },
        { Name: 'Receiver ID 2 Qualifier', PropertyName: 'IdentificationQualifier2', PropertyNamespace: 'http://link.bizbrains.com/properties/partner-out' },
        { Name: 'Receiver ID 3', PropertyName: 'IdentificationValue3', PropertyNamespace: 'http://link.bizbrains.com/properties/partner-out' },
        { Name: 'Receiver ID 3 Qualifier', PropertyName: 'IdentificationQualifier3', PropertyNamespace: 'http://link.bizbrains.com/properties/partner-out' },

        { Name: 'Sender ID 1', PropertyName: 'IdentificationValue', PropertyNamespace: 'http://link.bizbrains.com/properties/partner-in' },
        { Name: 'Sender ID 1 Qualifier', PropertyName: 'IdentificationQualifier', PropertyNamespace: 'http://link.bizbrains.com/properties/partner-in' },
        { Name: 'Sender ID 2', PropertyName: 'IdentificationValue2', PropertyNamespace: 'http://link.bizbrains.com/properties/partner-in' },
        { Name: 'Sender ID 2 Qualifier', PropertyName: 'IdentificationQualifier2', PropertyNamespace: 'http://link.bizbrains.com/properties/partner-in' },
        { Name: 'Sender ID 3', PropertyName: 'IdentificationValue3', PropertyNamespace: 'http://link.bizbrains.com/properties/partner-in' },
        { Name: 'Sender ID 3 Qualifier', PropertyName: 'IdentificationQualifier3', PropertyNamespace: 'http://link.bizbrains.com/properties/partner-in' }
    ];
    allowAdding = false;
    allowUpdating = false;
    allowDeleting = false;
    allowShowLog = false;
    allowAddingQualifier = false;
    allowUpdatingQualifier = false;
    allowDeletingQualifier = false;
    dropDownOptions = { width: 500 };

    constructor(
        private developerService: DeveloperService,
        private loadingPanelService: LoadingPanelService,
        private toastService: ToastService,
        private currentUserService: CurrentUserService,
        private gridService: GridService,
        public bizGridFiltervalues: BizGridFiltervalues) {
    }

    ngOnInit(): void {
        this.allowAdding = this.currentUserService.hasPermission('Developer_Action_XmlPropertyPromotion_Create');
        this.allowUpdating = this.currentUserService.hasPermission('Developer_Action_XmlPropertyPromotion_Edit');
        this.allowDeleting = this.currentUserService.hasPermission('Developer_Action_XmlPropertyPromotion_Delete');
        this.allowShowLog = this.currentUserService.hasPermission('Developer_Action_ShowLog');
    }

    onEditingStart(e) {
        const prop = this.getSelectedProperty(e.data.PropertyName, e.data.PropertyNamespace);
        e.data.Property = prop.Name;
        this.isSystemProperty = prop.Name !== 'Custom';
    }

    onEditorPreparing(e) {
        if (e.dataField === 'Description' && e.parentType === 'dataRow') {
            e.editorName = 'dxTextArea';
        }

        if (e.caption === 'System Property' && e.parentType === 'dataRow') {
            e.editorOptions.onValueChanged = (ev) => {
                const selectedItem = ev.component.option('selectedItem');
                e.setValue(selectedItem);
            };
        }
    }

    async ngAfterViewInit(): Promise<void> {
        await this.refresh();
    }

    async refresh(): Promise<void> {
        try {
            this.loadingPanelService.showLoadingPanelDirect('Loading...');

            await Promise.all([
                this.developerService.getXmlPropertyPromotionFilters().then(result => { this.xmlPropertyPromotionFilters = result; }),
            ]);
        }
        catch (err) {
            console.error(err);
            this.toastService.showToast('Failed to load data...', ToastType.error);
        }
        finally {
            this.loadingPanelService.hideLoadingPanel();
        }
    }

    onInitNewRow(e: any): void {
        e.data = {
            Id: null,
            RootNamespace: '',
            RootNode: '',
            XpathField: '',
            XpathValue: '',
            Description: '',
            Fields: []
        } as XmlPropertyPromotionFilter;
    }

    onRowInserting = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow(e.data as XmlPropertyPromotionFilterEntity, item => this.saveXmlPropertyPromotionFilter(item));
    };

    onRowUpdating = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow({ ...e.key, ...e.newData } as XmlPropertyPromotionFilterEntity, item => this.saveXmlPropertyPromotionFilter(item), e.newData);
    };

    onRowRemoving = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow(e.data as XmlPropertyPromotionFilterEntity, item => this.deleteXmlPropertyPromotionFilter(item));
    };

    async deleteXmlPropertyPromotionFilter(item: XmlPropertyPromotionFilterEntity): Promise<XmlPropertyPromotionFilterEntity> {
        await this.developerService.deleteXmlPropertyPromotionFilter(item.Id);
        this.toastService.showToast('Document identification deleted...', ToastType.success);
        return item;
    }

    async saveXmlPropertyPromotionFilter(item: XmlPropertyPromotionFilterEntity): Promise<XmlPropertyPromotionFilterEntity> {
        const newItem = await this.developerService.saveXmlPropertyPromotionFilter(item);
        this.toastService.showToast('Document identification saved...', ToastType.success);
        return newItem;
    }

    onPropertyFieldInitNewRow(e: any, parent: XmlPropertyPromotionFilterEntity): void {
        e.data = {
            Id: null,
            PromotedPropertyFilterId: parent.Id,
            Xpath: '',
            PropertyName: '',
            PropertyNamespace: '',
            PropertyDefaultValue: null
        } as XmlPropertyPromotionFieldEntity;
    }

    onPropertyFieldRowInserting = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow(e.data as XmlPropertyPromotionFieldEntity, item => this.saveXmlPropertyPromotionField(item));
    };

    onPropertyFieldRowUpdating = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow({ ...e.key, ...e.newData } as XmlPropertyPromotionFieldEntity, item => this.saveXmlPropertyPromotionField(item), e.newData);
    };

    onPropertyFieldRowRemoving = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow(e.data as XmlPropertyPromotionFieldEntity, item => this.deleteXmlPropertyPromotionField(item));
    };

    async saveXmlPropertyPromotionField(item: XmlPropertyPromotionFieldEntity): Promise<XmlPropertyPromotionFieldEntity> {
        const newItem = await this.developerService.saveXmlPropertyPromotionField(item);
        this.toastService.showToast('Promoted property saved...', ToastType.success);
        return newItem;
    }

    async deleteXmlPropertyPromotionField(item: XmlPropertyPromotionFieldEntity): Promise<XmlPropertyPromotionFieldEntity> {
        await this.developerService.deleteXmlPropertyPromotionField(item.Id);
        this.toastService.showToast('Promoted property deleted...', ToastType.success);
        return item;
    }

    setCellValue = (rowData, value, currentRowData) => {
        if (value != null) {
            rowData.PropertyName = value.PropertyName || rowData.PropertyName;
            rowData.PropertyNamespace = value.PropertyNamespace || rowData.PropertyNamespace;
            rowData.Property = value.Name;

            const prop = this.getSelectedProperty(value.PropertyName, value.PropertyNamespace);
            this.isSystemProperty = prop.Name !== 'Custom';
        }
    };

    getSelectedProperty(name: string, namespace: string) {
        let prop = this.systemProperties.find(p => p.PropertyName === name && p.PropertyNamespace === namespace);
        if (prop == null) {
            prop = { Name: 'Custom', PropertyName: '', PropertyNamespace: '' };
        }
        return prop;
    }

    onXPathFieldValueChange($event: string, cell: ColumnEditCellTemplateData<XmlPropertyPromotionFilter, unknown>) {
        if (cell.value !== $event) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            cell.setValue($event);
        }
    }

    onXPathPropValueChange($event: string, cell: ColumnEditCellTemplateData<XmlPropertyPromotionFieldEntity, unknown>) {
        if (cell.value !== $event) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            cell.setValue($event);
        }
    }
}

export class SystemProperty {
    Name: string;
    PropertyName: string;
    PropertyNamespace: string;
}
